<template>
  <div style="padding-bottom: 70px;">
   <el-form label-width="150px" >
     <el-form-item label="收货工站照片:">
       <KfImageViewer :imageList="receiveImageList"/>
     </el-form-item>
     <el-form-item label="收货工站备注:">
       <el-input v-model="receiveData.remark" style="width: 50%" disabled/>
     </el-form-item>
     <el-form-item label="录单工站照片:">
       <KfImageViewer :imageList="inputImageList"/>
     </el-form-item>
     <el-form-item label="录单工站备注:">
       <el-input v-model="inputData.remark" style="width: 50%" disabled/>
     </el-form-item>
     <el-form-item label="产品确认:">
       <el-radio-group v-model="formData.product">
       <el-radio value="ok">OK</el-radio>
       <el-radio value="ng">NG</el-radio>
     </el-radio-group>
     </el-form-item>
     <el-form-item label="外观确认:">
       <el-radio-group v-model="formData.product_vi">
         <el-radio value="ok">OK</el-radio>
         <el-radio value="ng">NG</el-radio>
       </el-radio-group>
     </el-form-item>
     <el-form-item label="附件确认:" >
       <el-row style="width: 100%;">
         <el-col :span="2" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">附件</el-col>
         <el-col :span="2" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">寄送数量</el-col>
         <el-col :span="2" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">收货数量</el-col>
         <el-col :span="4" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">确认</el-col>
         <el-col :span="18" ></el-col>
       </el-row>
       <div v-for="appendix in buItemAppendix" :key="appendix.id" style="width: 100%;">
         <el-row style="">
           <el-col :span="2" style="text-align:center;">{{ appendix.appendix_type_name }}</el-col>
           <el-col :span="2" style="text-align:center;">{{appendix.appendix_cnt}}</el-col>
           <el-col :span="2" style="text-align:center;">{{appendix.appendix_receive_cnt}}</el-col>
           <el-col :span="4" style="text-align:center;">
             <el-radio-group v-model="appendix.appendix_result">
               <el-radio value="ok">OK</el-radio>
               <el-radio value="ng">NG</el-radio>
             </el-radio-group>
           </el-col>
           <el-col :span="18" ></el-col>
         </el-row>
       </div>
     </el-form-item>
     <el-form-item label="照片:" required>
       <FrameItem v-model="formData.image_ids" :item = item ></FrameItem>
     </el-form-item>
     <el-form-item label="OQC结果:">
       <el-select v-model="formData.result" placeholder="请选择OQC结果" clearable style="width: 34%">
         <el-option v-for="item in results" :key="item.value" :label="item.name" :value="item.value"></el-option>
       </el-select>
     </el-form-item>
   </el-form>
    <el-row class="oqcSubmit-row">
      <el-button @click="submit" :loading="loading">提交OQC结果</el-button>
      <KfMessage ref="submitMsg"></KfMessage>
    </el-row>
  </div>
</template>

<script>

import {ElMessageBox} from "element-plus";

export default {
  name: "StationOqc",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    stationId: String,
  },
  data() {
    return {
      loading: false,
      formData: {},
      buItemAppendix:[],
      receiveData:[],
      inputData:[],
      receiveImageList:[],
      inputImageList:[],
      item:{
        component: 'take_photo',
        data_key: 'image_ids',
        limit: 10,
        label: '照片',
        required: true
      }
    }
  },
  computed: {
    results() {
      return this.$store.getters['core/getDictList']('station_oqc_result');
    },
  },
  created() {
    this.getBuItemAppendix ()
    this.getReceiveData ()
    this.getInputData ()
  },
  mounted() {
  },
  methods: {

    //获取物品附件
    async getBuItemAppendix() {
        this.buItemAppendix = await this.$http('buItemService.getBuItemAppendix', {item_id: this.parentData.id,})
    },

    //获取收货工站照片
    async getReceiveData() {
      this.receiveData = await this.$http('buItemService.getReceiveData', {item_id: this.parentData.id,})
      this.receiveImageList = this.receiveData.image_list !== undefined ? this.receiveData.image_list : []
    },

    //获取录单工站照片
    async getInputData() {
      this.inputData = await this.$http('buItemService.getInputData', {item_id: this.parentData.id,})
      this.inputImageList = this.inputData.image_list !== undefined ? this.inputData.image_list : []
    },

    clearMessage() {
      this.$refs.submitMsg.clear()
    },
    reset() {
      this.formData = {}
      this.buItemAppendix = []
      // this.$refs.submitMsg.clear()
    },

    submit() {
      ElMessageBox.confirm(
          '确定提交当前工站作业结果吗？',
          '提示',
          {
            confirmButtonText: '确认',
            type: 'warning',
          }
      ).then(() => {
        this.submitResult()
      })
    },

    submitResult() {
      this.$refs.submitMsg.clear()
      if (!this.parentData.id) {
        this.$refs.submitMsg.showError('请先扫描SN进行查询');
        return;
      }

      if (!this.formData.product){
        this.$refs.submitMsg.showError('请选择产品确认');
        return;
      }
      if (!this.formData.product_vi){
        this.$refs.submitMsg.showError('请选择外观确认');
        return;
      }
      if (!this.formData.image_ids){
        this.$refs.submitMsg.showError('请拍照');
        return;
      }
      for (let i = 0; i < this.buItemAppendix.length; i++) {
        if (!this.buItemAppendix[i].appendix_result){
          this.$refs.submitMsg.showError('请选择第'+(i+1)+'行附件确认',);
          return;
        }
      }
      this.formData.appendixList = this.buItemAppendix;
      this.formData.id = this.parentData.id;
      this.loading = true;
      this.$http('buItemService.submitOqcResult', this.formData, false).then(data => {
        this.loading = false;
        this.$refs.submitMsg.showSuccess(data);
        this.reset()
        this.$fn.reset()
      }, errMsg => {
        this.loading = false;
        this.$refs.submitMsg.showError(errMsg);
      })
    }
  }
}
</script>

<style scoped lang="less">

.trouble-form{
  padding: 10px 0 0 0;
  width: 700px;
}

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}

.btn-row {
  padding: 5px 0;
}

.oqcSubmit-row {
  margin: 10px 0;
  padding-top: 0px;
  padding-left: 150px;
  //border-top: 1px solid #ddd;
}
</style>